import React from 'react';

export const useBulkSelect = () => {
  const [bulkSelectedItems, setBulkSelectedItems] = React.useState<Set<string>>(new Set());

  const handleItemSelect = (selectedItem: string) => {
    const selectedItems = new Set(bulkSelectedItems);

    selectedItems.has(selectedItem)
      ? selectedItems.delete(selectedItem)
      : selectedItems.add(selectedItem);

    setBulkSelectedItems(selectedItems);
  };

  const handleBulkSelectMultiple = (
    currentPageItems: string[],
    currentPageSelectedItems: string[],
  ) => {
    const hasSelectedItemsOnPage = currentPageSelectedItems.length > 0;
    const newBulkSelectedItems = new Set(bulkSelectedItems);

    currentPageItems.forEach((item) => {
      hasSelectedItemsOnPage ? newBulkSelectedItems.delete(item) : newBulkSelectedItems.add(item);
    });

    setBulkSelectedItems(newBulkSelectedItems);
  };

  const handleBulkDeselectAll = () => {
    setBulkSelectedItems(new Set());
  };

  return {
    bulkSelectedItems,
    handleItemSelect,
    handleBulkSelectMultiple,
    handleBulkDeselectAll,
  };
};
